import React from "react";
import {
  IntervalUnit,
  INTERVAL_UNITS,
  RecurrenceType,
  RECURRENCE_TYPES,
} from "../../../services/api";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Label } from "@/components/ui/label";
import { INTERVAL_UNIT_LABELS, RECURRENCE_LABELS } from "../utils";

interface Props {
  recurrenceType: RecurrenceType;
  intervalValue: number | null;
  intervalUnit: IntervalUnit | null;
  onChange: (state: { recurrenceType: RecurrenceType; intervalValue: number | null; intervalUnit: IntervalUnit | null }) => void;
}

export const RecurrenceEditor: React.FC<Props> = ({ recurrenceType, intervalValue, intervalUnit, onChange }) => {
  return (
    <div className="space-y-2">
      <Label>Recurrencia</Label>
      <div className="flex flex-wrap gap-2 items-center">
        <Select
          value={recurrenceType}
          onValueChange={(v) => onChange({
            recurrenceType: v as RecurrenceType,
            intervalValue,
            intervalUnit,
          })}
        >
          <SelectTrigger className="w-48"><SelectValue /></SelectTrigger>
          <SelectContent>
            {RECURRENCE_TYPES.map((r) => (
              <SelectItem key={r} value={r}>{RECURRENCE_LABELS[r]}</SelectItem>
            ))}
          </SelectContent>
        </Select>

        {recurrenceType === "Interval" && (
          <>
            <span className="text-sm text-slate-600">cada</span>
            <Input
              type="number"
              min={1}
              className="w-24"
              value={intervalValue ?? ""}
              onChange={(e) => onChange({
                recurrenceType,
                intervalValue: e.target.value ? parseInt(e.target.value, 10) : null,
                intervalUnit,
              })}
            />
            <Select
              value={intervalUnit ?? "Months"}
              onValueChange={(v) => onChange({
                recurrenceType,
                intervalValue,
                intervalUnit: v as IntervalUnit,
              })}
            >
              <SelectTrigger className="w-32"><SelectValue /></SelectTrigger>
              <SelectContent>
                {INTERVAL_UNITS.map((u) => (
                  <SelectItem key={u} value={u}>{INTERVAL_UNIT_LABELS[u]}</SelectItem>
                ))}
              </SelectContent>
            </Select>
          </>
        )}
      </div>
    </div>
  );
};
